export function isBase64Image(val: any) {
  return val?.split(',')[0]?.split(';')?.pop() === 'base64';
}
